import React, { useState } from "react";
import "./Contact.scss";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { newcolor } from "../../constants/color";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log({ name, email, message });
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/addContactInfo`,
      method: "post",
      data: {
        name: name,
        email: email,
        message: message,
        userId: userId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        if (response?.data?.status == true) {
          // getCartProductDetails();
          toast.success("Form Submit Successfully", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  return (
    <div>
      <div className="contact-outer">
        <div className="contact-inner">
          <div className="contact-head">
            <h1>CONTACT US</h1>
          </div>

          <div className="contact-content">
            <div className="contact-form col-md-12">
              <div className="contact-form-inner">
                <form onSubmit={handleSubmit}>
                  <div className="contact-name">
                    <h6>Name</h6>
                    <div className="input-section row">
                      <div className="input1 col-md-12">
                        <input
                          type="text"
                          name="name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                          placeholder="Full name"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="contact-email">
                    <h6>Email</h6>
                    <div className="input-section">
                      <div className="input1-email">
                        <input
                          type="email"
                          name="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          placeholder="Email"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="contact-message">
                    <h6>Message</h6>
                    <div className="input-section">
                      <div className="input1-message">
                        <textarea
                          name="message"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          rows="4"
                          required
                          placeholder="Message"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="contact-submit mb-5">
                    <div className="submit-inner">
                      <button
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-info ">
          <div className="contact-getintouch ">
            <div className="head">
              <h2>Get In Touch</h2>
            </div>
            <div className="text">
              <div className="subhead">
                <b>EMAIL:</b> &nbsp;
                <Link
                  to="mailto:Info@rare.in"
                  style={{
                    textDecoration: "none",
                    border: "none",
                    color: "black",
                  }}
                >
                  Info@rare.in,
                </Link>
                &nbsp;&nbsp;{" "}
                <Link
                  to="mailto:raerofficialclothing@gmail.com"
                  style={{
                    textDecoration: "none",
                    border: "none",
                    color: "black",
                  }}
                >
                  raerofficialclothing@gmail.com
                </Link>
              </div>
              {/* <div className="body">
                  <Link to="mailto:Info@rare.in">Info@rare.in,</Link>
                  <br />
                  <Link to="mailto:raerofficialclothing@gmail.com">
                    raerofficialclothing@gmail.com
                  </Link>
                </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
